import {Col} from "./layout.col.c";
import {ThreeCol} from "./layout.three-col.c";


export const Layout = {
	Col,
	ThreeCol
}
